import React from "react";
import { Routes, Route } from "react-router-dom";
import ListConsultant from "../Components/consultants/ListConsultant";
import AddConsultant from "../Components/consultants/AddConsultant";
import ViewConsultant from "../Components/consultants/ViewConsultant";
const ConsultantRoutes = () => {
  return (
    <Routes>
      <Route path="/Consultants" element={<ListConsultant />}></Route>
       <Route path="/Consultants/add" element={<AddConsultant/>}></Route>
      <Route path="/Consultants/view/:id" element={<ViewConsultant/>}></Route>
      {/*<Route path="/builders/:id/review" element={}></Route> */}
    </Routes>
  );
};

export default ConsultantRoutes;
